// Risk Pool Service for FlexibleCRUDTable
// Custom service that transforms risk pool data to match FlexibleCRUDTable expectations

import { RiskService } from './riskService';

export class RiskPoolService {
  private riskService: RiskService;

  constructor() {
    this.riskService = new RiskService();
  }

  // Get all risks with pagination
  async getAll(params: any = {}) {
    const { page = 1, limit = 20, ...filters } = params;
    
    try {
      const result = await this.riskService.getRiskPool(filters, page, limit);
      
      // Transform the data to match FlexibleCRUDTable expectations
      return {
        data: result.risks,
        pagination: {
          page: page,
          limit: limit,
          total: result.pagination?.total || result.risks.length,
          totalPages: Math.ceil((result.pagination?.total || result.risks.length) / limit)
        }
      };
    } catch (error) {
      console.error('Error fetching risk pool:', error);
      throw error;
    }
  }

  // Create a new risk
  async create(data: any) {
    return await this.riskService.createRisk(data);
  }

  // Update a risk
  async update(id: string, data: any) {
        try {
      const response = await this.riskService.updateRisk(id, data);
            return response;
    } catch (error) {
      console.error('RiskPoolService.update failed:', error);
      throw error;
    }
  }

  // Delete a risk
  async delete(id: string) {
    return await this.riskService.deleteRisk(id);
  }

  // Get a single risk by ID
  async getById(id: string) {
    return await this.riskService.getRiskById(id);
  }
}

export const riskPoolService = new RiskPoolService();
